/**
 * Stringly-typed transaction status — matches the BE's `statusName` field on
 * every endpoint that surfaces a Transaction (payment callback envelope,
 * branch-tables endpoint, etc.).
 *
 * The BE also ships a numeric `status` field on these responses (1 = Open,
 * 2 = PartiallyPaid, 4 = Cancelled, …); we deliberately do NOT encode the
 * numeric ordering here because the full enum isn't documented on the FE
 * and could shift if the BE inserts new statuses. Compare against
 * `TransactionStatus.*` (the string name) — that's the stable contract.
 *
 * Domain reference: see `.claude/rules/domain.md` "Transaction Status".
 */
export enum TransactionStatus {
  /** Active, accepting payments. */
  Open = 'Open',
  /** Has payments but not fully paid yet. */
  PartiallyPaid = 'PartiallyPaid',
  /** Bill completely paid. */
  FullyPaid = 'FullyPaid',
  /** Cancelled by user. */
  Cancelled = 'Cancelled',
  /** Payment refunded. */
  Refunded = 'Refunded',
  /** All items voided in POS. */
  Voided = 'Voided',
  /** System cancelled. */
  SystemCancelled = 'SystemCancelled',
  /** Closed when a new transaction starts on the same table. */
  Closed = 'Closed',
}
